var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{attrs:{"to":{
    name: 'EmployeeDetails',
    params: { shorthand: _vm.item.shorthand }
  }},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.item.firstName)+" "+_vm._s(_vm.item.lastName))]),_c('v-list-item-subtitle',[_vm._v(" "+_vm._s(_vm.$t('employeeDetails.shorthand'))+": "+_vm._s(_vm.item.shorthand)+" "),_c('span',{staticClass:"px-2"},[_vm._v("–")]),_vm._v(" "+_vm._s(_vm.$t('employeeDetails.supervisor'))+": "+_vm._s(_vm.item.supervisorName)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }